// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"5a09d21d","862":"4440c697","928":"a0ebc951"}[chunkId] + ".chunk.js";
};